<template>

	<div>

    <router-view/>
		
	</div>
  
</template>

<style type="text/css">
  .pointer { cursor: pointer !important; }
</style>

<script>
import utility from '@/mixins/utility'

import { mapGetters } from 'vuex'

export default {
  name: 'App',

  mixins: [ utility ],

  components:
  {
    
  },

  data: () => ({
    //
  }),

  computed:
  {
    ...mapGetters({
      isLoading: 'ui/isLoading'
    })
  },

  mounted()
  {
    if( this.$route.name === 'layout' )
      this.goTo('home')
  },

  watch: {}
};
</script>
